import { render, staticRenderFns } from "./BidModifiers.vue?vue&type=template&id=616f1a1d"
import script from "./BidModifiers.vue?vue&type=script&lang=js"
export * from "./BidModifiers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports